/* export const SERVER_URL =
  "https://dev.inlab.istanbul/kanalistanbul-api/public/api/"; */

/* export const SERVER_URL = "http://172.16.34.51/api/"; */
export const SERVER_URL = "https://kanalistanbul.uab.gov.tr/api/";
